var _rect, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgPride = function SvgPride(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 16,
    viewBox: "0 0 24 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 24,
    height: 15,
    rx: 2,
    fill: "url(#pattern0)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_23879_32872",
    transform: "scale(0.015625 0.025)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_23879_32872",
    width: 64,
    height: 40,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEAAAAAoBAMAAAC84OHaAAAABGdBTUEAALGPC/xhBQAAACBjSFJNAAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAAAIVBMVEXlAADuLgD/jQD/zgD/7gACgSEBcGoATP9PGbB3AIj///+TOM8CAAAAAWJLR0QKaND0VgAAAAd0SU1FB+cFGgs2EkYhts0AAAA3SURBVDjLY2AYFkCQAGBQIgCGhgJjAoDBhQAYGgpCCYChoSCNAGAoJwCGhoIOAoBhJgEwJBQAAH6AfpDmsuHUAAAAJXRFWHRkYXRlOmNyZWF0ZQAyMDIzLTA1LTI2VDExOjU0OjE4KzAwOjAwS6PFGQAAACV0RVh0ZGF0ZTptb2RpZnkAMjAyMy0wNS0yNlQxMTo1NDoxOCswMDowMDr+faUAAAAASUVORK5CYII="
  }))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgPride);
export default ForwardRef;